module.exports = __webpack_public_path__ + "img/revolut.7d1f024c.png";